import useApiFetchV2, {useApiFetchV2Request} from "../useApiFetchV2";

export module Profile {
    export type Permission = "admin";
    export type RoleNames = 'admin';

    export interface Role {
        id: number;
        name: RoleNames;
    }

    export interface RootObject {
        id: string;
        phone?: any;
        email: string;
        name: string;
        gender: string;
        birthdate: string;
        created_at: Date;
        updated_at: Date;
        is_disabled: boolean;
        roles: Role[];
    }


}



export const useLoggedinProfile = () => {
    return useApiFetchV2<Profile.RootObject>('me', {params: {include: 'cities,roles,vendor-admin'}})
}


export const useProfileUpdate = () => {
    return  useApiFetchV2Request<Profile.RootObject>('profile')
}
